var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-third-menu",class:{
    show: _vm.show,
  },style:({
    left: _vm.left,
    width: _vm.width,
  }),on:{"mouseenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selfShow.apply(null, arguments)},"mouseleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.setHide.apply(null, arguments)}}},_vm._l((_vm.menus),function(item,index){return _c('div',{key:index,staticClass:"third-menu-item",on:{"click":function($event){$event.stopPropagation();return _vm.handleMenuItem(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }